import { Header } from '@/components/Header.tsx'
import { AnalyticsSidebar } from '@/components/analytics/AnalyticsSidebar.tsx'
import { SidebarProvider } from '@/components/ui/sidebar.tsx'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const ProjectAnalyticsLayout = ({ children }: Props) => {
  return (
    <div className="flex flex-col w-screen bg-surface-background">
      <Header className="fixed" />
      <SidebarProvider
        style={{
          // @ts-ignore
          '--sidebar-width': '178px',
          '--sidebar-width-mobile': '178px',
        }}
      >
        <AnalyticsSidebar />
        <div className="overflow-auto mt-[100px] min-[1000px]:mt-[60px] px-12 py-8 max-w-[836px] w-full">
          {children}
        </div>
      </SidebarProvider>
    </div>
  )
}
